import React, { useState } from 'react';
import { db } from '../services/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../services/firebase';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';

const Register = () => {
  const [mobile, setMobile] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [otpId, setOtpId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const nav = useNavigate();

  // Send OTP using cloud function
  const sendOtp = async () => {
    if (mobile.length !== 10) {
      alert("Enter valid 10-digit number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Check if already registered (optional check - can skip if collection doesn't exist yet)
      try {
        const docRef = doc(db, 'superadmins', mobile);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          alert("This mobile number is already registered. Please login.");
          setLoading(false);
          return;
        }
      } catch (checkErr) {
        // If collection doesn't exist, continue with registration
        console.log("Could not check existing user:", checkErr);
      }

      // Send OTP via Cloud Function
      const sendOTP = httpsCallable(functions, 'sendOTP');
      const response = await sendOTP({
        mobile,
        useCase: 'REGISTRATION',
        validity: 10,
        params: {},
      });

      if (response.data.success) {
        setOtpId(response.data.otpId);
        setOtpSent(true);
        alert("OTP sent successfully! Please check your mobile.");
      } else {
        setError(response.data.message || "Failed to send OTP");
        alert(response.data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      setError(err.message || "Failed to send OTP");
      alert(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP and Register
  const verifyOtpAndRegister = async () => {
    if (!otp || !password || !confirmPass) {
      alert("Fill all fields");
      return;
    }

    if (password !== confirmPass) {
      alert("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      alert("Password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Verify OTP using cloud function
      const verifyOTP = httpsCallable(functions, 'verifyOTP');
      const verifyResponse = await verifyOTP({
        otpId,
        otp,
        mobile,
        useCase: 'REGISTRATION',
      });

      if (!verifyResponse.data.success) {
        setError(verifyResponse.data.message || "Invalid OTP");
        alert(verifyResponse.data.message || "Invalid OTP");
        setLoading(false);
        return;
      }

      // Hash password
      const passwordHash = await bcrypt.hash(password, 10);

      // Create superadmin document
      await setDoc(doc(db, 'superadmins', mobile), {
        mobile,
        passwordHash,
        createdAt: new Date(),
        updatedAt: new Date(),
      });

      alert("Registration successful! Please login.");
      nav("/superadminlogin");
    } catch (err) {
      console.error("Registration error:", err);
      setError(err.message || "Registration failed");
      alert(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title">JMI</h1>
      <p className="subtitle">Super Admin</p>

      <div className="login-box">
        <h2>Registration</h2>

        <label>Mobile Number</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/, ''))}
          disabled={otpSent}
        />

        {!otpSent ? (
          <button 
            className="login-btn" 
            onClick={sendOtp}
            disabled={loading}
          >
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        ) : (
          <>
            <label>OTP</label>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/, ''))}
              maxLength={6}
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password (min 6 characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />

            <button 
              className="login-btn" 
              onClick={verifyOtpAndRegister}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Register"}
            </button>
          </>
        )}
      </div>

      {error && <p className="error">{error}</p>}

      <p className="register-link">
        Already have an account? <span onClick={() => nav("/superadminlogin")}>Login</span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        Need help? Contact Seller Support
      </p>
    </div>
  );
};

export default Register;